import {API} from "@/Composables/api";

const getQuestionResponses = async (question, params = {}) => {
    return API.get(route("questions.responses.index", question), params);
};

const exportMultipleQuestions = async (params = {}) => {
    return API.get(route("questions.export-multiple"), params);
};

export {getQuestionResponses, exportMultipleQuestions};
